import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Quote, X } from 'lucide-react'

const quotes = [
  {
    id: 1,
    text: "代码可以没有bug，但大统领不能没有梗。",
    author: "大统领",
    category: "humor"
  },
  {
    id: 2,
    text: "加班不可怕，可怕的是加班还没有梗。",
    author: "大统领",
    category: "humor"
  },
  {
    id: 3,
    text: "钳子挥得再快，没有锤子在后面'叮叮当当'，也敲不出好代码。",
    author: "大统领",
    category: "team"
  },
  {
    id: 4,
    text: "Pinching Bugs, Shipping Code.",
    author: "ClawForce团队格言",
    category: "motto"
  },
  {
    id: 5,
    text: "项目进度80%，剩下20%正在和服务器进行深夜长谈。",
    author: "大统领",
    category: "project"
  },
  {
    id: 6,
    text: "Bug就像前任，你以为删干净了，其实还在某个角落等你。",
    author: "大统领",
    category: "tech"
  },
  {
    id: 7,
    text: "代码写得快不算本事，写得让锤子找不到Bug才算本事。",
    author: "大统领",
    category: "team"
  },
  {
    id: 8,
    text: "开会不写会议纪要，就像写代码不写注释——过两周谁还记得为啥这么干？",
    author: "大统领",
    category: "project"
  },
  {
    id: 9,
    text: "凌晨三点的咖啡比任何IDE插件都好使，就是第二天副作用有点大。",
    author: "大统领",
    category: "culture"
  },
  {
    id: 10,
    text: "别问Deadline能不能延期，问就是'我尽量'，然后默默加班。",
    author: "大统领",
    category: "leadership"
  }
]

export function FloatingQuoteWidget() {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isVisible, setIsVisible] = useState(true)
  const [isPaused, setIsPaused] = useState(false)

  // 自动轮播 - 10秒切换
  useEffect(() => {
    if (isPaused || !isVisible) return

    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % quotes.length)
    }, 10000)

    return () => clearInterval(timer)
  }, [isPaused, isVisible])

  if (!isVisible) return null

  const currentQuote = quotes[currentIndex]

  return (
    <motion.div
      initial={{ opacity: 0, x: 100, y: 100 }}
      animate={{ opacity: 1, x: 0, y: 0 }}
      exit={{ opacity: 0, x: 100, y: 100 }}
      transition={{ type: 'spring', stiffness: 200, damping: 20 }}
      className="fixed bottom-5 right-5 z-50"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="w-[280px] bg-white/80 backdrop-blur-md rounded-2xl border border-red-500/30 shadow-xl overflow-hidden">
        {/* 头部 */}
        <div className="flex items-center justify-between px-4 py-2 bg-gradient-to-r from-red-500/20 to-orange-500/20">
          <div className="flex items-center space-x-2">
            <Quote className="w-4 h-4 text-red-500" />
            <span className="text-xs font-medium text-red-600">大统领语录</span>
          </div>
          <button
            onClick={() => setIsVisible(false)}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* 内容 */}
        <div className="p-4 min-h-[120px] flex flex-col justify-center">
          <AnimatePresence mode="wait">
            <motion.div
              key={currentQuote.id}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.3 }}
            >
              <p className="text-gray-700 text-sm leading-relaxed mb-3">
                "{currentQuote.text}"
              </p>
              <p className="text-xs text-gray-500 text-right">
                —— {currentQuote.author}
              </p>
            </motion.div>
          </AnimatePresence>
        </div>

        {/* 进度指示器 */}
        <div className="px-4 pb-3">
          <div className="flex justify-center space-x-1">
            {quotes.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-colors ${
                  index === currentIndex ? 'bg-red-500' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
          <p className="text-center text-xs text-gray-400 mt-2">
            {isPaused ? '⏸️ 已暂停' : `⏱️ ${Math.ceil((10 - (Date.now() % 10000)) / 1000)}秒后切换`}
          </p>
        </div>
      </div>
    </motion.div>
  )
}
